import { StyleSheet } from 'react-native'
import { ApplicationStyles, Metrics } from 'APP/Themes'
import styled from 'styled-components/native'
import { LinearGradient } from 'expo-linear-gradient'
import { hexToRgba } from 'APP/Helpers/styling'

export default StyleSheet.create({
  ...ApplicationStyles.screen,
  centeredContainer: {
    alignItems: 'center',
    paddingHorizontal: Metrics.baseMargin,
  },
  spacedColumnContainer: {
    flexDirection: 'column',
    marginTop: Metrics.baseMargin,
    marginBottom: Metrics.baseMargin * 2,
  },
  buttonContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    marginHorizontal: Metrics.baseMargin * 2,
  },
  button: {
    marginBottom: Metrics.baseMargin / 2,
  },
  spacedRowContainer: {
    flexDirection: 'row',
  },
  avatarContainer: {
    marginTop: Metrics.baseMargin * 2,
    marginBottom: Metrics.baseMargin,
    borderRadius: 60,
    zIndex: 0,
  },
  roundImage: {
    width: 120,
    height: 120,
    borderRadius: 60,
  },
})

export const StyledLinearGradient = styled(LinearGradient).attrs(({ theme }) => ({
  colors: [hexToRgba(theme.colors.gradientStart, 0.9), hexToRgba(theme.colors.gradientEnd, 0.9)],
  start: { x: 1, y: 0 },
  end: { x: 0, y: 1 },
}))`
  flex: 1;
  justify-content: center;
  align-items: center;
`
